var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.wrapperElement,_vm._b({tag:"component",staticClass:"relative"},'component',_vm.wrapperAttributes,false),[_c('ul',_vm._b({ref:"list",class:[
      'list-none',
      // Placement
      'flex',
      'justify-between',
      'items-center',
      // Spacing
      'm-0',
      'p-0',
      // Custom classes
      _vm.tabsContainerClasses,
    ],attrs:{"role":_vm.listRole}},'ul',_vm.listAttributes,false),[_vm._l((_vm.tabs),function(tab,index){return [_c('li',{key:tab.key,ref:tab.key,refInFor:true,attrs:{"role":_vm.listItemRole}},[_c('OzTextButton',_vm._b({class:[
            'flex items-center',
            'outline-none',
            _vm.sizePreset == _vm.SizePreset.H42px && ['h-[2.625rem]', 'rounded-2xl', 'px-2', 'text-heading-3'],
            _vm.sizePreset == _vm.SizePreset.H59px && ['h-[3.6875rem]', 'rounded-2.5xl', 'px-3', 'text-heading-1'],
            // Font
            'font-semibold',
            // Base
            _vm.currentTabKey === tab.key
              ? {
                  'text-grape-500': _vm.darkMode === false,
                  'text-canary-500': _vm.darkMode === true,
                  'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
                }
              : {
                  'text-dark-text-200': _vm.darkMode === false,
                  'text-light-text-200': _vm.darkMode === true,
                  'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
                },
            // Hovered
            {
              'hhover:text-dark-text-100': _vm.darkMode === false,
              'hhover:text-light-text-100': _vm.darkMode === true,
              'hhover:text-dark-text-100 dark:hhover:text-light-text-100': _vm.darkMode === 'auto',
            },
            // Focused
            'ring-inset',
            _vm.sizePreset == _vm.SizePreset.H42px && 'hfocus-visible:ring-[2.5px]',
            _vm.sizePreset == _vm.SizePreset.H59px && 'hfocus-visible:ring-4',
            {
              'hfocus-visible:ring-grape-500': _vm.darkMode === false,
              'hfocus-visible:ring-canary-500': _vm.darkMode === true,
              'hfocus-visible:ring-grape-500 dark:hfocus-visible:ring-canary-500': _vm.darkMode === 'auto',
            },
            // Active
            {
              'hactive:text-grape-500': _vm.darkMode === false,
              'hactive:text-canary-500': _vm.darkMode === true,
              'hactive:text-grape-500 dark:hactive:text-canary-500': _vm.darkMode === 'auto',
            },
          ],attrs:{"data-cy":`${tab.key}Tab`,"href":tab.href,"href-mode":tab.hrefMode,"color-scheme":_vm.OzTextButtonColorScheme.Bare,"dark-mode":_vm.darkMode,"text":tab.text},on:{"click":function($event){return _vm.$emit('activate-tab', $event, { key: tab.key })}}},'OzTextButton',_vm.computeTabAttributes(tab),false))],1),_vm._v(" "),(index !== _vm.tabs.length - 1)?_c('li',{key:`${tab.key}-divider`,class:[
          _vm.sizePreset == _vm.SizePreset.H42px && 'text-body-large',
          _vm.sizePreset == _vm.SizePreset.H59px && 'text-heading-1',
          'select-none',
          {
            'text-dark-text-400': _vm.darkMode === false,
            'text-light-text-400': _vm.darkMode === true,
            'text-dark-text-400 dark:text-light-text-400': _vm.darkMode === 'auto',
          },
        ],attrs:{"aria-hidden":"true","tabindex":"-1"}},[_vm._v("\n        /\n      ")]):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }